// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageProps from "@insite/client-framework/Types/PageProps";
import MobiusPage from "@insite/mobius/Page";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import PageModule from "@store/Framework/Types/PageModule";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    isArchived = "isArchived",
    publicationDate = "publicationDate",
    hideHourMinutes = "hideHourMinutes",
    categoriesList = "categoriesList",
    previewImage = "previewImage",
    blogSummary = "blogSummary",
}

interface OwnProps extends PageProps {
    fields: {
        [fields.isArchived]: boolean;
        [fields.publicationDate]: Date | null;
        [fields.hideHourMinutes]: boolean;
        [fields.categoriesList]: string[];
        [fields.previewImage]: string;
        [fields.blogSummary]: string;
    };
}

export interface BlogDetailsPageStyles {
    mobiusPage?: InjectableCss;
}

const blogDetailsPageStyles: BlogDetailsPageStyles = {
    mobiusPage: {
        css: css`
            ${breakpointValues(pxToRemArray([965, null, null, null, 995]), "max-width")};
        `,
    },
};

const styles = blogDetailsPageStyles;

const BlogDetailsPage: React.FunctionComponent<OwnProps> = ({ id }) => (
    <MobiusPage {...styles.mobiusPage}>
        <Zone contentId={id} zoneName="Content" />
    </MobiusPage>
);

const settingsTab = {
    displayName: "Settings",
    sortOrder: 2,
};

const pageModule: PageModule<Toolkit.FieldDefinition> = {
    component: BlogDetailsPage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        allowedParents: ["BlogListPage"],
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            {
                ...HorizontalRule,
                sortOrder: 150,
            },
            {
                name: fields.isArchived,
                displayName: "Blog is Archived",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                tab: settingsTab,
            },
            {
                name: fields.publicationDate,
                displayName: "Publication Date",
                defaultValue: null,
                editorTemplate: "UTCDateTimeField",
                fieldType: "General",
                isRequired: true,
                tab: settingsTab,
            },
            {
                name: fields.hideHourMinutes,
                displayName: "Hide Hour and Minutes from Date",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
                tab: settingsTab,
            },
            {
                name: fields.previewImage,
                displayName: "Preview Image 16:9",
                fieldType: "Translatable",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                tooltip: "Image format in Blog Details Page is 16:9",
                tab: settingsTab,
            },
            {
                name: fields.categoriesList,
                displayName: "Categories",
                editorTemplate: "SystemListCheckboxField",
                systemListName: "RSLBlogCategories",
                defaultValue: [],
                fieldType: "General",
                tooltip: "To add further items to this list, go to Admin, then System lists.",
                tab: settingsTab,
            },
            {
                name: fields.blogSummary,
                displayName: "Summary",
                defaultValue: "",
                editorTemplate: "MultilineTextField",
                fieldType: "Translatable",
                isRequired: true,
                tab: settingsTab,
            },
        ],
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "BlogDetailsPage" instead of this constant.
 */
export const BlogDetailsPageContext = "BlogDetailsPage";
